/**
 * Upload PUT via XHR com progresso (fetch não expõe onprogress no upload).
 * @param {string} url
 * @param {Blob|File} body
 * @param {string} contentType
 * @param {(info: { loaded: number, total: number, percent: number }) => void} [onProgress]
 * @returns {Promise<void>}
 */
export function uploadWithProgress(url, body, contentType, onProgress) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();

    xhr.upload.onprogress = (event) => {
      if (!event.lengthComputable || typeof onProgress !== "function") return;
      onProgress({
        loaded: event.loaded,
        total: event.total,
        percent: Math.min(100, Math.round((event.loaded / event.total) * 100)),
      });
    };

    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        resolve();
      } else {
        reject(new Error(`Falha no upload (${xhr.status})`));
      }
    };
    xhr.onerror = () => reject(new Error("Erro de rede no upload"));
    xhr.onabort = () => reject(new Error("Upload cancelado"));

    xhr.open("PUT", url);
    xhr.setRequestHeader("Content-Type", contentType || "application/octet-stream");
    xhr.send(body);
  });
}
